export class UpiRequest {
    public amount: string;
    public phone: string;
    public userId: string;
}

export class UpiStatusRequest {
    public txn_date: Date;
    public client_txn_id: string;
    public userId: string;
    public isCallBack: boolean;
}


export class phonePePan {
    public amount: string;
    public phone: string;
    public userId: string;
    public aadhar: string;
    public pan: string;
    public panHolder: string;
}